import { Box, Paper, Typography } from '@mui/material';

const Index = () => {
  return (
    <Box sx={{ marginTop: '5px' }}>
      <Paper
        sx={{
          position: 'relative',
          overflow: 'hidden',
          borderRadius: '26px',
          px: { xs: 3, sm: 6 },
          py: { xs: 5, sm: 8 },
          textAlign: 'center',
          background: 'linear-gradient(160deg, rgba(255,255,255,0.82), rgba(255,255,255,0.5))',
        }}>
        {/* Halos decorativos */}
        <Box
          sx={{
            position: 'absolute',
            top: -120,
            left: -80,
            width: 320,
            height: 320,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(95,214,198,0.45), transparent 68%)',
            filter: 'blur(40px)',
            pointerEvents: 'none',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            bottom: -140,
            right: -90,
            width: 340,
            height: 340,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(179,169,247,0.42), transparent 68%)',
            filter: 'blur(46px)',
            pointerEvents: 'none',
          }}
        />

        <Box sx={{ position: 'relative' }}>
          <Box
            component='img'
            src='images/fondoWhite.png'
            alt='Safety Sound'
            sx={{
              height: { xs: 92, sm: 120 },
              objectFit: 'contain',
              mb: 3,
              filter: 'drop-shadow(0 14px 30px rgba(16,58,74,0.16))',
            }}
          />

          <Typography
            variant='caption'
            component='div'
            sx={{
              color: 'text.disabled',
              fontWeight: 700,
              letterSpacing: '0.2em',
              fontSize: '0.62rem',
              textTransform: 'uppercase',
              mb: 1,
            }}>
            Panel de gestión
          </Typography>

          <Typography
            variant='h4'
            sx={{
              fontWeight: 800,
              letterSpacing: '-0.03em',
              background: 'linear-gradient(120deg, #0A7A6E 0%, #0E9F8F 42%, #7C6CF0 110%)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}>
            Bienvenido a la página de inicio de Safety Sound.
          </Typography>

          <Box
            sx={{
              width: 64,
              height: 4,
              borderRadius: 999,
              mx: 'auto',
              mt: 3,
              background: 'linear-gradient(90deg, #5FD6C6, #7C6CF0)',
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default Index;
